import React, { useState } from "react";
import Logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import ReorderIcon from "@material-ui/icons/Reorder";
import "../styles/Navbar.css";
import CloseIcon from '@material-ui/icons/Close';

function Navbar() {
  const [openLinks, setOpenLinks] = useState(false);

  const toggleNavbar = () => {
    setOpenLinks(!openLinks);
    
  };

  const closeicon=<CloseIcon/>
  const reorder=<ReorderIcon/>
  return (
    <div className="navbar">
      <div className="leftSide" id={openLinks ? "open" : "close"}>
        <img src={Logo} />
        <div className="hiddenLinks">
          <Link to="/"> Home </Link>
          <Link to="/services"> Services </Link>
          <Link to="/gallery"> Gallery </Link>
          <Link to="/contact"> Contact </Link>
        </div>
      </div>
      <div className="rightSide">
        <Link to="/"> Home </Link>
        <Link to="/services"> Services </Link>
        <Link to="/Gallery"> Gallery </Link>
        <Link to="/contact"> Contact </Link>
        <button onClick={toggleNavbar}>
          { openLinks ?  closeicon :reorder    }
        </button>
      </div>
    </div>
  );
}

export default Navbar;
